import {useEffect, useState} from "react";

import SwitchView from "@/components/SwitchView";
import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";

import {REQUIRED_FIELD, rpeOptions} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

function HandleRPEModal(props) {
	const {open, confirm, close, initialData, internalTeams, players} = props;

	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState([]);

	const [insertType, setInsertType] = useState(
		initialData?.id ? "single" : "multiple",
	);
	const [categoryType, setCategoryType] = useState(
		initialData?.matchCategoryId,
	);

	useEffect(() => {
		if (!open) {
			setFormData({});
		}
	}, [open]);

	const currentInternalTeam = internalTeams?.filter(
		(t) => t.playerCategoryId === initialData?.matchCategoryId,
	)?.[0];
	const categoryPlayers = currentInternalTeam?.players
		?.filter((p) => players?.find((tp) => tp.id === p.playerId))
		?.map((p) => p.player);

	const otherPlayers = players?.filter(
		(p) => p.categoryId !== initialData?.matchCategoryId,
	);

	useEffect(() => {
		if (initialData?.id) {
			const player = players?.filter(
				(r) => r.id === initialData?.playerId,
			)?.[0];

			setFormData({
				...formData,
				player: {
					value: player.id,
					label: player.firstName + " " + player.lastName,
				},
				rpe: {
					value: initialData?.rpe,
					label: rpeOptions.find((o) => o.value === initialData?.rpe)?.label,
				},
			});
		}
	}, [initialData]);

	useEffect(() => {
		if (insertType === "multiple") {
			const playersValues = {};
			categoryPlayers?.forEach((p) => {
				playersValues[p.id] = {
					player: {
						value: p.id,
						label: p.firstName + " " + p.lastName,
						sortKey: p.lastName,
					},
				};
			});
			setFormData({...formData, players: playersValues});
		}
	}, [insertType]);

	const requiredFields = insertType === "single" ? ["player", "rpe"] : [];

	const selectPlayers =
		categoryType === initialData?.matchCategoryId
			? categoryPlayers
			: otherPlayers;

	const formattedPlayers = selectPlayers?.map((p) => {
		return {
			value: p.id,
			label: p.firstName + " " + p.lastName,
			sortKey: p.lastName,
		};
	});

	return (
		<VLFModal
			maxWidth={insertType === "multiple" ? "lg" : "md"}
			open={open}
			title={"Aggiungi informazione"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData, insertType, initialData?.id);
				}
			}}
			content={
				<div className="row no-margin handle-rpe-modal-container">
					{!initialData?.id ? (
						<div className="col-12 padding-small">
							<SwitchView
								currentSwitchView={insertType}
								setCurrentSwitchView={(value) => {
									setInsertType(value);

									if (value === "multiple") {
										setCategoryType(initialData?.matchCategoryId);
									}
								}}
								pageOptions={[
									{value: "single", label: "Singolo"},
									{value: "multiple", label: "Multiplo"},
								]}
								fixed
								callback={() => {
									setFormData({
										player: null,
									});
								}}
							/>
						</div>
					) : null}
					{insertType === "single" && !initialData?.id ? (
						<div className="col-12 padding-small">
							<SwitchView
								currentSwitchView={categoryType}
								setCurrentSwitchView={setCategoryType}
								pageOptions={[
									{
										value: initialData?.matchCategoryId,
										label: initialData?.matchCategoryLabel,
									},
									{value: "others", label: "Altre categorie"},
								]}
								fixed
								callback={() => {
									setFormData({
										player: null,
									});
								}}
							/>
						</div>
					) : null}
					{insertType === "multiple" ? (
						<>
							{categoryPlayers
								?.sort((a, b) => {
									const nameA = a?.lastName.toLowerCase();
									const nameB = b?.lastName.toLowerCase();

									if (nameA < nameB) return -1;
									if (nameA > nameB) return 1;
									return 0;
								})
								?.map((p, k) => {
									return (
										<div key={k} className="col-sm-12 padding-small">
											<div className="single-rpe-player d-flex align-items-center">
												<div className="single-rpe-value">
													<VLFSelectNew
														options={formattedPlayers}
														sortKey="sortKey"
														value={formData?.players?.[p.id]?.player || ""}
														onChange={(value) => {
															setFormData({
																...formData,
																players: {
																	...formData?.players,
																	[p.id]: {
																		...formData?.players[p.id],
																		player: value,
																	},
																},
															});
														}}
														label="Giocatore"
													/>
												</div>
												<div className="single-rpe-value">
													<VLFSelectNew
														options={rpeOptions}
														sorted={false}
														value={formData?.players?.[p.id]?.rpe || ""}
														onChange={(value) => {
															setFormData({
																...formData,
																players: {
																	...formData?.players,
																	[p.id]: {
																		...formData?.players[p.id],
																		rpe: value,
																	},
																},
															});
														}}
														label="RPE"
													/>
												</div>
											</div>
										</div>
									);
								})}
						</>
					) : (
						<>
							<div className="col-sm-12 col-md-6 padding-small">
								<VLFSelectNew
									options={formattedPlayers}
									sortKey="sortKey"
									value={
										initialData?.id
											? formData?.player?.label
											: formData?.player || ""
									}
									onChange={(value) => {
										setErrors([]);
										setFormData({...formData, player: value});
									}}
									editable={!initialData?.id}
									required
									helperText={
										errors.indexOf("player") !== -1 ? REQUIRED_FIELD : ""
									}
									error={errors.indexOf("player") !== -1}
									label="Giocatore"
								/>
							</div>
							<div className="col-sm-12 col-md-6 padding-small">
								<VLFSelectNew
									options={rpeOptions}
									sorted={false}
									value={formData.rpe || ""}
									onChange={(value) => {
										setErrors([]);
										setFormData({...formData, rpe: value});
									}}
									required
									helperText={
										errors.indexOf("rpe") !== -1 ? REQUIRED_FIELD : ""
									}
									error={errors.indexOf("rpe") !== -1}
									label="RPE"
								/>
							</div>
						</>
					)}
				</div>
			}
		/>
	);
}

export default HandleRPEModal;
